import React, { Component } from 'react';

class DividerLine extends React.Component {
    render() {
        let styles = {
            background: '#ccc',
            width: '1px',
            margin: '0px 24px',
            ...this.props.styles
        }
        let classes = 'flex-grow-0';
        
        if(this.props.horizontal){
            styles = {
                ...styles,
                width: '100%',
                height: '1px',
                margin: '18px 0px',
                ...this.props.styles
            }
            classes = 'flex w-full'
        }

        if(this.props.dashed){
            styles = {
                ...styles,
                border: '1px dashed #ccc',
                background: 'transparent'
            }
        }
        
        return(
            <div className={classes + ' ' + this.props.className} style={styles}></div>
        )
    }
}

DividerLine.defaultProps = {
    horizontal: false,
    className: ''
}
  

export default DividerLine;

